import React, {memo} from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useTranslation} from 'react-i18next';
import api from 'api';
import {useDispatch} from 'react-redux';
import {layoutActions} from 'features/layout/redux';
import {unpackId} from 'common/diplomatIdUtil';
import Dialog from 'components/Dialog';
import {Grid} from '@mui/material';
import FormikTextField from 'components/inputs/FormikTextField';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import {usePutApi} from 'common/hooks/usePutApi';
import Formik from 'components/hook-form/Formik';

const validationSchema = yup.object({
   folderName: yup.string().required(),
});

interface RenameFolderDialogProps {
   onClose: () => void;
   data: INav;
}
const RenameFolderDialog = memo(({data, onClose}: RenameFolderDialogProps) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const {id} = unpackId(data?.id);
   const onSuccess = () => {
      dispatch(layoutActions.loadTreeNav());
      onClose();
   };
   const {request: rename} = usePutApi(`${api.folders}/${id}`, {onSuccess, onFailure: onClose});

   return (
      <Dialog maxWidth="sm" header={t('Rename folder')} close={onClose}>
         <Formik
            initialValues={validationSchema.cast({folderName: data?.name})}
            validationSchema={validationSchema}
            onSubmit={(values) => rename(JSON.stringify(values))}
         >
            <>
               <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={8}>
                     <FormikTextField
                        autoFocus
                        type="text"
                        name="folderName"
                        label={t('New Folder Name:')}
                     />
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                  <FormFooterButtons cancel={onClose} />
               </Grid>
            </>
         </Formik>
      </Dialog>
   );
});

export default RenameFolderDialog;
